var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("el-card", { staticClass: "box-card bg-purple" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header"
          },
          [
            _vm._v("Αναζήτηση Αιτήσεων:"),
            _c(
              "el-button",
              {
                staticStyle: { float: "right", padding: "3px 0" },
                attrs: { type: "text" },
                on: { click: _vm.toggleSearch }
              },
              [_vm._v("Κλείσιμο")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "text item" },
          [
            _c("el-input", {
              attrs: { placeholder: "Επώνυμο", type: "text" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchSurname,
                callback: function($$v) {
                  _vm.searchSurname = $$v
                },
                expression: "searchSurname"
              }
            }),
            _c("el-input", {
              attrs: { placeholder: "Όνομα", type: "text" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchFirstname,
                callback: function($$v) {
                  _vm.searchFirstname = $$v
                },
                expression: "searchFirstname"
              }
            }),
            _c("el-input", {
              attrs: {
                placeholder: "ΑΦΜ",
                maxlength: "9",
                "show-word-limit": "show-word-limit"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchAfm,
                callback: function($$v) {
                  _vm.searchAfm = $$v
                },
                expression: "searchAfm"
              }
            }),
            _c("el-input", {
              attrs: {
                placeholder: "Αρ. Πρωτοκόλλου",
                "suffix-icon": "el-icon-search"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchProtocolNum,
                callback: function($$v) {
                  _vm.searchProtocolNum = $$v
                },
                expression: "searchProtocolNum"
              }
            }),
            _c("el-input", {
              attrs: {
                placeholder: "Αρ. Πράξης",
                "suffix-icon": "el-icon-search"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchActNum,
                callback: function($$v) {
                  _vm.searchActNum = $$v
                },
                expression: "searchActNum"
              }
            }),
            _c("el-input", {
              attrs: {
                placeholder: "Αρ. Αίτησης",
                "suffix-icon": "el-icon-search"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchAppNum,
                callback: function($$v) {
                  _vm.searchAppNum = _vm._n($$v)
                },
                expression: "searchAppNum"
              }
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "Ημ. Γέννησης",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchBirthdate,
                callback: function($$v) {
                  _vm.searchBirthdate = $$v
                },
                expression: "searchBirthdate"
              }
            }),
            _c("el-tooltip", { attrs: { placement: "right" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "Επώνυμο: Τουλάχιστον 2 ελληνικούς ή 4 αγγλικούς χαρακτήρες"
                ),
                _c("br"),
                _vm._v('Όνομα: Αναζήτηση τύπου "αρχίζει με"'),
                _c("br"),
                _vm._v("ΑΦΜ: 9 ψηφία"),
                _c("br"),
                _vm._v(
                  "Αρ. Πρωτ.: π.χ. Α/21-2019 , όπου Α ελληνικά. Δυνατότητα αναζήτησης με %"
                ),
                _c("br"),
                _vm._v(
                  "Αρ. Πράξης: π.χ. Η25.3ΕΜ18/2019 , όπου H αγγλικά, Ε/Β/Δ/Μ ελληνικά. Δυνατότητα αναζήτησης με %"
                ),
                _c("br"),
                _vm._v("Αρ. Αίτησης: Αριθμός καταχώρησης αίτησης"),
                _c("br"),
                _vm._v(
                  "Ημ. Γέννησης: Αναζήτηση μόνο με ημέρα-μήνα, όχι έτος γέννησης"
                )
              ]),
              _c("i", { staticClass: "el-icon-question" })
            ]),
            _c("hr"),
            _c(
              "el-select",
              {
                staticClass: "big",
                attrs: {
                  placeholder: "Στάδιο Αίτησης",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { change: _vm.handleSearchPage },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchStatus,
                  callback: function($$v) {
                    _vm.searchStatus = $$v
                  },
                  expression: "searchStatus"
                }
              },
              _vm._l(_vm.appStates, function(appState) {
                return _c("el-option", {
                  key: appState.id,
                  attrs: { label: appState.gr_name, value: appState.name }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingRoles,
                    expression: "gettingRoles"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Ρόλος",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getRoles },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchRole,
                  callback: function($$v) {
                    _vm.searchRole = $$v
                  },
                  expression: "searchRole"
                }
              },
              _vm._l(_vm.roles, function(role) {
                return _c("el-option", {
                  key: role.id,
                  attrs: { label: role.gr_name, value: role.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingPresidentDecisions,
                    expression: "loadingPresidentDecisions"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Απόφαση Προέδρου",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { focus: _vm.getDecisions },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchDecision,
                  callback: function($$v) {
                    _vm.searchDecision = $$v
                  },
                  expression: "searchDecision"
                }
              },
              _vm._l(_vm.presidentDecisions, function(decision) {
                return _c("el-option", {
                  key: decision.id,
                  attrs: { label: decision.decision_text, value: decision.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                staticClass: "big",
                attrs: {
                  placeholder: "Τύπος Αίτησης",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchType,
                  callback: function($$v) {
                    _vm.searchType = $$v
                  },
                  expression: "searchType"
                }
              },
              _vm._l(_vm.appTypes, function(appType) {
                return _c("el-option", {
                  key: appType.id,
                  attrs: { label: appType.name, value: appType.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                staticClass: "big",
                attrs: {
                  placeholder: "Τύπος Φοίτησης",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchModeOfStudy,
                  callback: function($$v) {
                    _vm.searchModeOfStudy = $$v
                  },
                  expression: "searchModeOfStudy"
                }
              },
              _vm._l(_vm.appDistanceLearning, function(appStudyMode) {
                return _c("el-option", {
                  key: appStudyMode.val,
                  attrs: { label: appStudyMode.desc, value: appStudyMode.val }
                })
              })
            ),
            _c(
              "el-select",
              {
                staticClass: "big",
                attrs: {
                  placeholder: "Κατάσταση υποβολής",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchSubmissionStatus,
                  callback: function($$v) {
                    _vm.searchSubmissionStatus = $$v
                  },
                  expression: "searchSubmissionStatus"
                }
              },
              _vm._l(_vm.reappSubmissionStatuses, function(
                reappSubmissionStatus
              ) {
                return _c("el-option", {
                  key: reappSubmissionStatus.val,
                  attrs: {
                    label: reappSubmissionStatus.desc,
                    value: reappSubmissionStatus.val
                  }
                })
              })
            ),
            _c(
              "el-select",
              {
                staticClass: "big",
                attrs: {
                  placeholder:
                    "Αντισταθμιστικά μέτρα (Συμπληρωματικές εξετάσεις)",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchCompensatoryMeasures,
                  callback: function($$v) {
                    _vm.searchCompensatoryMeasures = $$v
                  },
                  expression: "searchCompensatoryMeasures"
                }
              },
              _vm._l(_vm.compensatoryMeasuresTypes, function(
                compensatoryMeasuresType
              ) {
                return _c("el-option", {
                  key: compensatoryMeasuresType.val,
                  attrs: {
                    label: compensatoryMeasuresType.desc,
                    value: compensatoryMeasuresType.val
                  }
                })
              })
            ),
            _c("el-tooltip", { attrs: { placement: "right" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "Στάδιο Αίτησης/Απόφαση Προέδρου/Τύπος Αίτησης/Τύπος φοίτησης/"
                ),
                _c("br"),
                _vm._v(
                  "Κατάσταση υποβολής/Αντισταθμιστικά μέτρα: Αναζήτηση στο γενικό σύνολο των αιτήσεων"
                ),
                _c("br"),
                _vm._v(
                  "Ρόλος: Αναζήτηση στο σύνολο των αιτήσεων που έχετε διεκπεραιώσει από τον κάθε ρόλο σας"
                )
              ]),
              _c("i", { staticClass: "el-icon-question" })
            ]),
            _c("hr"),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "8px" } },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "margin-right": "8px", "font-size": "13px" }
                  },
                  [_vm._v("Πανεπιστήμια:")]
                ),
                _c(
                  "el-button-group",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: _vm.instituteType === "new" ? "primary" : "",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            _vm.instituteType = "new"
                          }
                        }
                      },
                      [_vm._v("Νέα")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: _vm.instituteType === "old" ? "primary" : "",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            _vm.instituteType = "old"
                          }
                        }
                      },
                      [_vm._v("Παλιά")]
                    )
                  ],
                  1
                ),
                _c("el-tooltip", { attrs: { placement: "right" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      "Εμφανίζονται προς επιλογή τα νέα ή τα παλιά πανεπιστήμια της χώρας, αντίστοιχα"
                    )
                  ]),
                  _c("i", { staticClass: "el-icon-question" })
                ])
              ],
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "countries",
                attrs: {
                  placeholder: "Χώρα",
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { change: _vm.countrySelected },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchCountry,
                  callback: function($$v) {
                    _vm.searchCountry = $$v
                  },
                  expression: "searchCountry"
                }
              },
              _vm._l(_vm.countries, function(country) {
                return _c("el-option", {
                  key: country.id,
                  attrs: { label: country.name, value: country.id }
                })
              })
            ),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingUniversities,
                    expression: "gettingUniversities"
                  }
                ],
                staticClass: "big",
                attrs: {
                  placeholder: "Πανεπιστήμια",
                  disabled: _vm.disableUniversity,
                  filterable: "filterable",
                  clearable: "clearable"
                },
                on: { change: _vm.universitySelected },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.searchApps($event)
                  }
                },
                model: {
                  value: _vm.searchUniversity,
                  callback: function($$v) {
                    _vm.searchUniversity = $$v
                  },
                  expression: "searchUniversity"
                }
              },
              _vm._l(_vm.filteredUniversities, function(university) {
                return _c(
                  "el-option",
                  {
                    key: university.id,
                    attrs: { label: university.name, value: university.id }
                  },
                  [_vm._v(_vm._s(university.name))]
                )
              })
            ),
            _vm.instituteType === "old"
              ? [
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        placeholder: "Κολλέγια",
                        disabled: _vm.disableCollege,
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      on: { change: _vm.collegeSelected },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "enter", 13, $event.key)
                          ) {
                            return null
                          }
                          _vm.searchApps($event)
                        }
                      },
                      model: {
                        value: _vm.searchCollege,
                        callback: function($$v) {
                          _vm.searchCollege = $$v
                        },
                        expression: "searchCollege"
                      }
                    },
                    _vm._l(_vm.colleges, function(college) {
                      return _c(
                        "el-option",
                        {
                          key: college.id,
                          attrs: { label: college.name, value: college.id }
                        },
                        [_vm._v(_vm._s(college.name))]
                      )
                    })
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        placeholder: "Σχολές",
                        disabled: _vm.disableFaculty,
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      on: { change: _vm.facultySelected },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "enter", 13, $event.key)
                          ) {
                            return null
                          }
                          _vm.searchApps($event)
                        }
                      },
                      model: {
                        value: _vm.searchFaculty,
                        callback: function($$v) {
                          _vm.searchFaculty = $$v
                        },
                        expression: "searchFaculty"
                      }
                    },
                    _vm._l(_vm.faculties, function(faculty) {
                      return _c(
                        "el-option",
                        {
                          key: faculty.id,
                          attrs: { label: faculty.name, value: faculty.id }
                        },
                        [_vm._v(_vm._s(faculty.name))]
                      )
                    })
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        placeholder: "Τμήματα",
                        disabled: _vm.disableDepartment,
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "enter", 13, $event.key)
                          ) {
                            return null
                          }
                          _vm.searchApps($event)
                        }
                      },
                      model: {
                        value: _vm.searchDepartment,
                        callback: function($$v) {
                          _vm.searchDepartment = $$v
                        },
                        expression: "searchDepartment"
                      }
                    },
                    _vm._l(_vm.departments, function(department) {
                      return _c(
                        "el-option",
                        {
                          key: department.id,
                          attrs: {
                            label: department.name,
                            value: department.id
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    })
                  )
                ]
              : _vm._e(),
            _c("el-tooltip", { attrs: { placement: "right" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "Αναζήτηση βάσει τους ιδρύματος του πτυχίου προς αναγνώριση"
                )
              ]),
              _c("i", { staticClass: "el-icon-question" })
            ]),
            _c("hr"),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "Πράξεις από...",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchActDateFrom,
                callback: function($$v) {
                  _vm.searchActDateFrom = $$v
                },
                expression: "searchActDateFrom"
              }
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "...Πράξεις έως",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchActDateTo,
                callback: function($$v) {
                  _vm.searchActDateTo = $$v
                },
                expression: "searchActDateTo"
              }
            }),
            _c("el-tooltip", { attrs: { placement: "right" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v("Ημερομηνία ολοκλήρωσης της αναγνώρισης (ψηφιακής"),
                _c("br"),
                _vm._v("υπογραφής του εγγράφου) από τον πρόεδρο [από...έως]")
              ]),
              _c("i", { staticClass: "el-icon-question" })
            ]),
            _c("hr"),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "Υποβληθείσες από...",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchSubmitDateFrom,
                callback: function($$v) {
                  _vm.searchSubmitDateFrom = $$v
                },
                expression: "searchSubmitDateFrom"
              }
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "...Υποβληθείσες έως",
                format: "dd-MM-yyyy",
                "value-format": "dd-MM-yyyy"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.searchApps($event)
                }
              },
              model: {
                value: _vm.searchSubmitDateTo,
                callback: function($$v) {
                  _vm.searchSubmitDateTo = $$v
                },
                expression: "searchSubmitDateTo"
              }
            }),
            _c("el-tooltip", { attrs: { placement: "right" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v("Ημερομηνία πρώτης οριστικής υποβολής"),
                _c("br"),
                _vm._v("της αίτησης από τον πολίτη [από...έως]")
              ]),
              _c("i", { staticClass: "el-icon-question" })
            ]),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "popover",
                    rawName: "v-popover:popover",
                    arg: "popover"
                  }
                ],
                staticClass: "searchButton",
                attrs: { type: "primary" },
                on: { click: _vm.searchApps }
              },
              [_vm._v("Αναζήτηση Αιτήσεων")]
            ),
            _c("p", [
              _vm._v("Πλήθος αιτήσεων: " + _vm._s(_vm.countSearchedApps))
            ]),
            _c("el-switch", {
              attrs: { "active-text": "Εμφάνιση στηλών", "inactive-text": "" },
              model: {
                value: _vm.showFilters,
                callback: function($$v) {
                  _vm.showFilters = $$v
                },
                expression: "showFilters"
              }
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilters,
                    expression: "showFilters"
                  }
                ]
              },
              [
                _c("el-checkbox", {
                  attrs: { label: "Id", name: "showId" },
                  model: {
                    value: _vm.showId,
                    callback: function($$v) {
                      _vm.showId = $$v
                    },
                    expression: "showId"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Επώνυμο", name: "showSurname" },
                  model: {
                    value: _vm.showSurname,
                    callback: function($$v) {
                      _vm.showSurname = $$v
                    },
                    expression: "showSurname"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Όνομα", name: "showFirstname" },
                  model: {
                    value: _vm.showFirstname,
                    callback: function($$v) {
                      _vm.showFirstname = $$v
                    },
                    expression: "showFirstname"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Email", name: "showEmail" },
                  model: {
                    value: _vm.showEmail,
                    callback: function($$v) {
                      _vm.showEmail = $$v
                    },
                    expression: "showEmail"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Τύπος Αίτησης",
                    name: "showApplicationType"
                  },
                  model: {
                    value: _vm.showApplicationType,
                    callback: function($$v) {
                      _vm.showApplicationType = $$v
                    },
                    expression: "showApplicationType"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Στάδιο Αίτησης",
                    name: "showApplicationStatus"
                  },
                  model: {
                    value: _vm.showApplicationStatus,
                    callback: function($$v) {
                      _vm.showApplicationStatus = $$v
                    },
                    expression: "showApplicationStatus"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "ID απόφασης", name: "showDecisionId" },
                  model: {
                    value: _vm.showDecisionId,
                    callback: function($$v) {
                      _vm.showDecisionId = $$v
                    },
                    expression: "showDecisionId"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Απόφαση", name: "showDecisionText" },
                  model: {
                    value: _vm.showDecisionText,
                    callback: function($$v) {
                      _vm.showDecisionText = $$v
                    },
                    expression: "showDecisionText"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Ημ/νια Σταδίου",
                    name: "showStatusCreatedAt"
                  },
                  model: {
                    value: _vm.showStatusCreatedAt,
                    callback: function($$v) {
                      _vm.showStatusCreatedAt = $$v
                    },
                    expression: "showStatusCreatedAt"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Ημ/νια Κατάθεσης", name: "showDateCreated" },
                  model: {
                    value: _vm.showDateCreated,
                    callback: function($$v) {
                      _vm.showDateCreated = $$v
                    },
                    expression: "showDateCreated"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Ημ/νια Ολοκλ. Προελέγχου",
                    name: "showDateCompleted"
                  },
                  model: {
                    value: _vm.showDateCompleted,
                    callback: function($$v) {
                      _vm.showDateCompleted = $$v
                    },
                    expression: "showDateCompleted"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { label: "Αρ. πρωτοκόλλου", name: "showProtocol" },
                  model: {
                    value: _vm.showProtocol,
                    callback: function($$v) {
                      _vm.showProtocol = $$v
                    },
                    expression: "showProtocol"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Ημ/νια Πρωτοκόλλησης",
                    name: "showProtocolDate"
                  },
                  model: {
                    value: _vm.showProtocolDate,
                    callback: function($$v) {
                      _vm.showProtocolDate = $$v
                    },
                    expression: "showProtocolDate"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: "Ακαδημαϊκή περιοχή",
                    name: "showacAdemicAreaName"
                  },
                  model: {
                    value: _vm.showacAdemicAreaName,
                    callback: function($$v) {
                      _vm.showacAdemicAreaName = $$v
                    },
                    expression: "showacAdemicAreaName"
                  }
                }),
                _c("hr")
              ],
              1
            ),
            _c("hr"),
            void 0,
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAudit,
                    expression: "showAudit"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.gettingAuditedApps,
                    expression: "gettingAuditedApps"
                  }
                ]
              },
              [
                _vm._v("Προσθήκη-Αφαίρεση Αιτήσεων σε Λίστα Ελέγχου"),
                _c("el-transfer", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.submitingAuditList,
                      expression: "submitingAuditList"
                    }
                  ],
                  attrs: {
                    titles: ["Προς ανάθεση", "Αιτήσεις που εχουν ανατεθεί"],
                    "button-texts": ["τέλος Ελέγχου", "προς Έλεγχο"],
                    data: _vm.allAuditedApps,
                    format: {
                      noChecked: "${total}",
                      hasChecked: "${checked}/${total}"
                    }
                  },
                  on: {
                    change: _vm.submitAuditList,
                    "left-check-change": _vm.appsToAuditChanged,
                    "right-check-change": _vm.appsToReleaseAuditChanged
                  },
                  model: {
                    value: _vm.auditApplications,
                    callback: function($$v) {
                      _vm.auditApplications = $$v
                    },
                    expression: "auditApplications"
                  }
                })
              ],
              1
            ),
            _c("hr", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAudit,
                  expression: "showAudit"
                }
              ]
            }),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSearchedApplications,
                    expression: "loadingSearchedApplications"
                  }
                ],
                ref: "filterTable",
                attrs: {
                  stripe: "stripe",
                  border: "border",
                  "highlight-current-row": "highlight-current-row",
                  data: _vm.tableData,
                  "default-sort": { prop: "dateCreated", order: "descending" }
                },
                on: { "row-dblclick": _vm.loadApp }
              },
              [
                _vm.showAudit
                  ? _c("el-table-column", {
                      attrs: {
                        label: "Για Έλεγχο",
                        fixed: "left",
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    round: "round",
                                    size: "mini",
                                    disabled: _vm.isAudited(scope.row.id)
                                  },
                                  on: {
                                    click: function($event) {
                                      ;(_vm.appClicked = scope.row),
                                        _vm.addToAuditList(_vm.appClicked)
                                    }
                                  }
                                },
                                [_vm._v("Έλεγχος")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm.showId
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        label: "id",
                        width: "60px",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showSurname
                  ? _c("el-table-column", {
                      attrs: { prop: "surname", label: "Επώνυμο", sortable: "" }
                    })
                  : _vm._e(),
                _vm.showFirstname
                  ? _c("el-table-column", {
                      attrs: { prop: "firstname", label: "Όνομα", sortable: "" }
                    })
                  : _vm._e(),
                _vm.showEmail
                  ? _c("el-table-column", {
                      attrs: { prop: "email", label: "E-mail", sortable: "" }
                    })
                  : _vm._e(),
                _vm.showApplicationType
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "applicationType",
                        width: "210px",
                        label: "Τύπος Αίτησης",
                        sortable: "",
                        filters: _vm.filterAppType,
                        "filter-method": _vm.filterHandler
                      }
                    })
                  : _vm._e(),
                _vm.showApplicationStatus
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "applicationStatus",
                        label: "Στάδιο Αίτησης",
                        sortable: "",
                        filters: _vm.filterAppStatus,
                        "filter-method": _vm.filterHandler
                      }
                    })
                  : _vm._e(),
                _vm.showDecisionId
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "decisionId",
                        label: "ID απόφασης",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showDecisionText
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "decisionText",
                        label: "Απόφαση",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showStatusCreatedAt
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "statusCreatedAt",
                        label: "Ημ/νια Σταδίου",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showDateCreated
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "dateCreated",
                        label: "Ημ/νια Κατάθεσης",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showDateCompleted
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "dateCompleted",
                        label: "Ημ/νια Ολοκλ. Προελέγχου",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showProtocol
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "protocol",
                        label: "Αρ. Πρωτ.",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showProtocolDate
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "protocolDate",
                        label: "Ημ/νια Πρωτ.",
                        sortable: ""
                      }
                    })
                  : _vm._e(),
                _vm.showacAdemicAreaName
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "academicAreaName",
                        label: "Ακαδ. Περιοχή",
                        sortable: "",
                        filters: _vm.filterAcademicAreaName,
                        "filter-method": _vm.filterHandler
                      }
                    })
                  : _vm._e(),
                [
                  "Admin",
                  "President",
                  "VicePresidentA",
                  "VicePresidentB"
                ].includes(_vm.activeRole)
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "stepUserOrBoard",
                        label: "Υπάλληλος Σταδίου",
                        sortable: ""
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("p", { staticStyle: { "font-size": "75%" } }, [
              _vm._v(
                "Αιτήσεις " +
                  _vm._s(this.searchedApps.from) +
                  " έως " +
                  _vm._s(this.searchedApps.to)
              )
            ]),
            _c("el-pagination", {
              attrs: {
                "hide-on-single-page": "true",
                "prev-text": "Προηγούμενο",
                "next-text": "Επόμενο",
                total: _vm.countSearchedApps,
                background: "",
                "current-page": _vm.currentPage,
                "page-sizes": [20, 50, 100, 200, 300, 400, 500],
                "page-size": 20,
                layout: "total, sizes, prev, pager, next",
                "page-count": Math.ceil(
                  this.searchedApps.total / this.searchedApps.per_page
                )
              },
              on: {
                "current-change": _vm.handleCurrentChange,
                "size-change": _vm.handleSizeChange,
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          2
        )
      ]),
      _vm.showDialog
        ? _c(
            "el-dialog",
            {
              attrs: { visible: _vm.showDialog, width: "90%" },
              on: {
                "update:visible": function($event) {
                  _vm.showDialog = $event
                }
              }
            },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingSearchedApplication,
                      expression: "loadingSearchedApplication"
                    }
                  ],
                  staticClass: "box-card bg-purple"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showSearchedApplication,
                              expression: "!showSearchedApplication"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            "Επιλέξτε μια αίτηση για να την δείτε αναλυτικά"
                          )
                        ]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSearchedApplication,
                              expression: "showSearchedApplication"
                            }
                          ]
                        },
                        [
                          _vm._v("Αίτηση:"),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v(" " + _vm._s(_vm.searchedApplication.id))]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.searchedApplication.protocol !== null,
                                  expression:
                                    "searchedApplication.protocol !== null"
                                }
                              ]
                            },
                            [
                              _vm._v(", Αριθμός Πρωτοκόλλου:"),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.searchedApplication.protocol)
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.searchedApplication.praxeisNo !== null,
                                  expression:
                                    "searchedApplication.praxeisNo !== null"
                                }
                              ]
                            },
                            [
                              _vm._v(", Αριθμός Πράξης:"),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.searchedApplication.praxeisNo)
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.recognized,
                                  expression: "recognized"
                                }
                              ]
                            },
                            [
                              _vm._v(", Ημερομηνία Αναγνώρισης:"),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(" " + _vm._s(_vm.dateRecognized))]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.recognized,
                                  expression: "recognized"
                                }
                              ]
                            },
                            [
                              _vm._v(", Ημερομηνία Παραλαβής:"),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(" " + _vm._s(_vm.dateReceived))]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "text item" },
                    [
                      _vm.showSearchedApplication
                        ? _c(
                            "el-tabs",
                            {
                              attrs: { stretch: true },
                              model: {
                                value: _vm.activeName,
                                callback: function($$v) {
                                  _vm.activeName = $$v
                                },
                                expression: "activeName"
                              }
                            },
                            [
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "Προσωπικά Στοιχεία",
                                    name: "first"
                                  }
                                },
                                [
                                  _c("personal-details", {
                                    attrs: {
                                      personalDetails:
                                        _vm.searchedApplication.personalDetails
                                    }
                                  })
                                ],
                                1
                              ),
                              !_vm.isReappraisal && !_vm.isPostExam
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: "Τίτλος Σπουδών",
                                        name: "second"
                                      }
                                    },
                                    [
                                      _c("titles", {
                                        attrs: {
                                          application: _vm.searchedApplication
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.searchedApplication.degreeType ===
                                "bachelor" &&
                              _vm.searchedApplication.consideration === true &&
                              _vm.searchedApplication.applicationType !==
                                "reappraisal"
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: "Συνυποβολή Τίτλου",
                                        name: "third"
                                      }
                                    },
                                    [
                                      _c("title-consideration", {
                                        attrs: {
                                          application: _vm.searchedApplication
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "Επισυναπτόμενα",
                                    name: "fourth"
                                  }
                                },
                                [
                                  _c("attached-documents", {
                                    attrs: {
                                      userComment:
                                        _vm.searchedApplication.userComment,
                                      attachedDocumentsTable:
                                        _vm.attachedDocumentsTable,
                                      appId: _vm.searchedApplication.id,
                                      role: _vm.role,
                                      neededDocuments:
                                        _vm.searchedApplication.neededDocuments
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "Ιστορικό",
                                    name: "fifth",
                                    lazy: true
                                  }
                                },
                                [
                                  _c("history-line", {
                                    attrs: {
                                      applicationHistory: _vm.searchedAppHistory
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.isReappraisal || _vm.isPostExam
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: "Σχετική αίτηση",
                                        name: "seventh",
                                        lazy: true
                                      }
                                    },
                                    [
                                      _c("relevant-app", {
                                        attrs: {
                                          relevantApp:
                                            _vm.searchedApplication
                                              .relevantApplication
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm.showSearchedApplication && _vm.activeRole === "Admin"
                ? _c(
                    "div",
                    { staticStyle: { float: "left" } },
                    [
                      _c("releaseButton", {
                        attrs: {
                          releaseOrReroute: "release",
                          popoverContent:
                            "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;\n          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                          tooltipContent:
                            "Η αίτηση θα επιστρέψει στον προέλεγχο",
                          releaseChecked: true,
                          workingApplicationId: _vm.searchedApplication.id,
                          releaseByUser: "Admin"
                        },
                        on: { releasedDoc: _vm.releaseOk }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showSearchedApplication && _vm.activeRole === "Admin"
                ? _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c("releaseButton", {
                        attrs: {
                          releaseOrReroute: "reroute",
                          popoverContent:
                            "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον Χειριστή;\n          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                          tooltipContent:
                            "Η αίτηση θα επιστρέψει στον Χειριστή",
                          releaseChecked: _vm.canReroute,
                          workingApplicationId: _vm.searchedApplication.id,
                          releaseByUser: "Admin"
                        },
                        on: { releasedDoc: _vm.releaseOk }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showSearchedApplication && _vm.activeRole === "Admin"
                ? _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c("releaseButton", {
                        attrs: {
                          releaseOrReroute: "rerouteToPrintDecisionQueue",
                          popoverContent:
                            "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στην Ουρά Καταχωρητών;\n          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                          tooltipContent:
                            "Η αίτηση θα επιστρέψει στην Ουρά Καταχωρητών",
                          releaseChecked: _vm.isStatusPrintDecision,
                          workingApplicationId: _vm.searchedApplication.id,
                          releaseByUser: "Admin"
                        },
                        on: { releasedDoc: _vm.releaseOk }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showRenotify
                ? _c("div", [
                    _c(
                      "b",
                      [
                        _vm._v("Ανακοινοποίηση Πράξης/Επιστολής"),
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploading,
                                expression: "uploading"
                              }
                            ],
                            ref: "uploadFinalAct",
                            staticClass: "upload-demo",
                            attrs: {
                              accept: ".pdf,.PDF",
                              "file-list": _vm.attachments[0],
                              "http-request": _vm.addAttachment(
                                _vm.searchedApplication.id
                              ),
                              "on-preview": _vm.handlePreview,
                              "on-remove": _vm.handleRemove,
                              "before-remove": _vm.handleBeforeRemove,
                              limit: 1,
                              action: "",
                              "auto-upload": true,
                              "show-file-list": true
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "trigger",
                                  size: "small",
                                  type: "primary"
                                },
                                slot: "trigger"
                              },
                              [_vm._v("Άνοιγμα Αρχείου")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: { size: "small", type: "success" },
                                on: { click: _vm.uploadAttachment }
                              },
                              [_vm._v("Αποστολή Αρχείου")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                attrs: { slot: "tip" },
                                slot: "tip"
                              },
                              [
                                _vm._v(
                                  "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα πράξης/επιστολής προς ανακοινοποίηση"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.showCreatePostExamAppButton
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.createPostExamApp }
                        },
                        [
                          _vm._v(
                            "Δημιουργία αίτησης για έκδοση πράξης μετά από εξετάσεις"
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb6a5b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb6a5b7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ApplicationSearch.vue
// module id = null
// module chunks = 